import React from 'react';
import type { ContractorOnboardStep, ContractorOnboardStepId } from '../../../types/contractorOnboard';

type Props = {
  steps: ContractorOnboardStep[];
  onSelect?: (id: ContractorOnboardStepId) => void;
};

const ContractorPipeline: React.FC<Props> = ({ steps, onSelect }) => {
  return (
    <nav className="hiring-pipeline" aria-label="1099 contractor pipeline">
      {steps.map((step, idx) => (
        <React.Fragment key={step.id}>
          {idx > 0 && <span className="hiring-pipeline-sep" aria-hidden>›</span>}
          <button
            type="button"
            className={`hiring-pipeline-step hiring-pipeline-step--${step.state}`}
            disabled={step.state === 'locked' || step.state === 'upcoming'}
            onClick={() => onSelect?.(step.id)}
          >
            {step.label}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default ContractorPipeline;
